<template>
    <div>
        <raw-material-component/>
    </div>
</template>

<script>

export default {
  name: 'RawMaterialView',
}
</script>